import { IEligibilityAction, IEligibilityContextState } from './eligibility-interfaces';
import { eligibilityActionTypes } from './eligibility-action-types';

export const eligibilityReducer = (state: IEligibilityContextState, action?: IEligibilityAction): IEligibilityContextState => {
	switch (action.type) {
		case eligibilityActionTypes.FETCH_FINGERPRINTS_LIST: {
			return {
				...state,
				fingerprintsList: action.payload,
			};
		}
		case eligibilityActionTypes.START_SET_BLOCK_LOADING: {
			return {
				...state,
				isSetBlockLoading: true,
			};
		}
		case eligibilityActionTypes.END_SET_BLOCK_LOADING: {
			return {
				...state,
				isSetBlockLoading: false,
			};
		}
		case eligibilityActionTypes.START_BLOCK_LIST_LOADING: {
			return {
				...state,
				isBlockListLoading: true,
			};
		}
		case eligibilityActionTypes.FETCH_BLOCK_LIST: {
			return {
				...state,
				blockList: action.payload,
				blockListTotalItemCount: action.totalItemCount,
				isBlockListLoading: false
			};
		}
		case eligibilityActionTypes.SET_BLOCK_LIST_TABLE_PAGINATION: {
			return { ...state, blockListTablePageSize: action.payload.pageSize, blockListTablePageNumber: action.payload.pageNumber };
		}
		case eligibilityActionTypes.FAILED_LOADING: {
			return {
				...state,
				isSetBlockLoading: false,
			};
		}
		default: {
			return state;
		}
	}
};
